import React from 'react';
import { Box, Button, Heading, VStack, FormControl, FormLabel, Input, Select, Divider, Text, HStack, Badge } from '@chakra-ui/react';
import { CreditCard, ExternalLink } from 'lucide-react';
import { DashboardLayout } from '../layouts/DashboardLayout';
export const Settings = () => {
  const openBillingPortal = () => {
    // This would typically make an API call to your backend
    // which would then create a Stripe Billing Portal session
    window.open('https://billing.stripe.com/p/login/test', '_blank');
  };
  return <DashboardLayout>
      <Box maxW="800px">
        <Heading size="lg" mb={8}>
          Settings
        </Heading>
        <VStack spacing={8} align="stretch">
          <Box>
            <Text fontSize="lg" fontWeight="medium" mb={4}>
              Billing & Subscription
            </Text>
            <Box bg="gray.800" p={6} borderRadius="lg" border="1px" borderColor="gray.700">
              <VStack align="stretch" spacing={4}>
                <HStack justify="space-between">
                  <VStack align="start" spacing={1}>
                    <Text color="gray.300">Current Plan</Text>
                    <HStack>
                      <Text color="white" fontSize="lg" fontWeight="bold">
                        Pro Plan
                      </Text>
                      <Badge colorScheme="green" variant="subtle">
                        Active
                      </Badge>
                    </HStack>
                  </VStack>
                  <Button leftIcon={<CreditCard size={18} />} rightIcon={<ExternalLink size={16} />} bg="#ff3d00" color="white" onClick={openBillingPortal} _hover={{
                  bg: '#e53700',
                  boxShadow: '0 0 20px rgba(255, 61, 0, 0.5)'
                }}>
                    Manage Billing
                  </Button>
                </HStack>
                <Text color="gray.400" fontSize="sm">
                  Manage your subscription, payment methods, and billing history
                </Text>
              </VStack>
            </Box>
          </Box>
          <Divider borderColor="gray.700" />
          <Box>
            <Text fontSize="lg" fontWeight="medium" mb={4}>
              Account Settings
            </Text>
            <VStack spacing={4} bg="gray.800" p={6} borderRadius="lg" border="1px" borderColor="gray.700">
              <FormControl>
                <FormLabel color="gray.300">Email</FormLabel>
                <Input bg="gray.700" border="none" color="white" defaultValue="user@example.com" />
              </FormControl>
              <FormControl>
                <FormLabel color="gray.300">Time Zone</FormLabel>
                <Select bg="gray.700" border="none" color="white" defaultValue="UTC">
                  <option value="UTC">UTC</option>
                  <option value="EST">Eastern Time</option>
                  <option value="PST">Pacific Time</option>
                </Select>
              </FormControl>
            </VStack>
          </Box>
          <Divider borderColor="gray.700" />
          <Box>
            <Text fontSize="lg" fontWeight="medium" mb={4}>
              Notification Preferences
            </Text>
            <VStack spacing={4} bg="gray.800" p={6} borderRadius="lg" border="1px" borderColor="gray.700">
              <FormControl>
                <FormLabel color="gray.300">Email Notifications</FormLabel>
                <Select bg="gray.700" border="none" color="white" defaultValue="important">
                  <option value="all">All Notifications</option>
                  <option value="important">Important Only</option>
                  <option value="none">None</option>
                </Select>
              </FormControl>
            </VStack>
          </Box>
          <Box>
            <Button bg="#ff3d00" color="white" _hover={{
            bg: '#e53700',
            boxShadow: '0 0 20px rgba(255, 61, 0, 0.5)'
          }}>
              Save Changes
            </Button>
          </Box>
        </VStack>
      </Box>
    </DashboardLayout>;
};